import { BerthDto } from '@storage/app/api'
import { EntityDialogFeatureStore } from '@storage/app/store/entity-dialog.feature-store'

export class BerthsDialogFeatureStore extends EntityDialogFeatureStore<BerthDto> {}
